import { render, staticRenderFns } from "./liCreateOrderV2.vue?vue&type=template&id=0383711e&scoped=true"
import script from "./liCreateOrderV2.vue?vue&type=script&lang=js"
export * from "./liCreateOrderV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0383711e",
  null
  
)

export default component.exports